// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"8e4cc532","102":"0dfcdd71","240":"dcc565e6","517":"f25c8c34","851":"1ab68b6c","905":"d3c1df2c"}[chunkId] + ".chunk.js";
};